import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentUser } from '../use-get-current-user';

/**
 * ### useBYOCStatus
 *
 * @description
 * Hook that checks if BYOC (Bring Your Own Community) is enabled for the current user's organization.
 * Fetches the entitlement definition and returns the BYOC status.
 *
 *
 * @returns Object containing isBYOLEnabled boolean and isLoading state
 */
export const useBYOCStatusByCurrentUser = () => {
  const { data: currentUser } = useGetCurrentUser();
  const orgId = currentUser?.organization?.id;

  const { data: entitlement, isLoading } =
    projectApi.useGetOrganizationsByOrgIdEntitlementDefnQuery(
      { orgId: orgId ?? 0 },
      { skip: !orgId },
    );

  const isBYOCEnabled = entitlement?.byoc?.isEnabled === true;

  return {
    isBYOCEnabled,
    isLoading,
  };
};
